export default __webpack_public_path__ + "static/noise-e09d0f87e83fe69298e7458cc71b05f7.jpg";